<template>
  <div class="page-box" v-if="form">
    <div class="info-box">
      <step :index="4"></step>
      <div class="verification-result">
        <div class="msg">主办单位证件: <span class="result" v-if="form.accountStatus == 3">通过</span></div>
        <div class="msg">主体负责人证件: <span class="result" v-if="form.accountFrontStatus == 3 && form.accountBackStatus == 3 ">通过</span></div>
        <div class="msg">网站负责人证件: <span class="result" v-if="form.rpkFrontStatus == 3 && form.rpkBackStatus == 3 ">通过</span></div>
        <div class="msg">网站负责人人脸核验: <span class="result" v-if="form.faceLiveStatus == 3">通过</span></div>
      </div>
      <div class="confirm-info" v-if="form.account">
        <div class="title">请确认信息真实性</div>
        <div class="msg" v-if="form.account.enterpriseName">主办单位名称: {{form.account.enterpriseName}}</div>
        <div class="msg">
          主办单位性质:
          <span class="result" v-if="form.dwxz == 5">个人</span>
          <span class="result" v-if="form.dwxz == 2">政府机关</span>
          <span class="result" v-if="form.dwxz == 3">事业单位</span>
          <span class="result" v-if="form.dwxz == 4">企业</span>
        </div>
        <div class="msg" v-if="form.account.legalPerson">主体负责人姓名: {{form.account.legalPerson}}</div>
      </div>
    </div>
    <div class="msg-box">
      <van-checkbox class="checkbox" v-model="checked" shape="square" icon-size="14px">
        <span class="text">本人郑重承诺，以上所提供材料真实有效，愿承担因使用不实材料核准造成的一切后果</span>
      </van-checkbox>
    </div>
    <div class="button-box">
      <van-button type="primary" class="btn" @click.prevent="onSubmit" :disabled="!checked">下一步</van-button>
    </div>
  </div>
</template>
<script>
import Step from '../components/Step.vue'
export default {
  components:{
    Step,
  },
  data() {
    return {
      checked:false,
      form:'',
    };
  },
  created() {
    this.getVerifyStatus();
  },
  methods: {
    getVerifyStatus(){
      let loading = this.$toast.loading({
        duration:0,
        overlay: true,
        forbidClick: true,
      });
      this.$apis.filingServer.getVerifyStatus({
        verifyToken:localStorage.getItem('verifyToken'),
        userAgent:localStorage.getItem('userAgent'),
      }).then(res=>{
        loading.clear();
        if (res['code'] == 0) {
          this.form = res['data'];
        } else {
          this.$dialog.alert({
            message: res['msg'],
            confirmButtonText:'好的',
            confirmButtonColor:'#4285f5',
          });
        }
      })
    },
    onSubmit(){
      const query = this.$route.query;
      this.$router.push({ path: '/filing/process/result/note', query });
    }
  }
};
</script>
<style lang="scss" scoped>
.page-box {
  max-width: 750px;
  margin: auto;
  padding: 50px;
  .info-box{
    .verification-result{
      margin: 40px 0;
      .msg{
        display: flex;
        justify-content: space-between;
        margin: 25px 0;
        font-size: 26px;
        .result{
          color: #039D12;
        }
      }
    }
    .confirm-info{
      padding-top: 20px;
      .title{
        margin-bottom: 40px;
        font-size: 32px;
        font-weight: bold;
      }
      .msg{
        display: flex;
        margin: 25px 0;
        font-size: 26px;
      }
    }
  }
  .msg-box{
    margin: 100px 0 ;
    .checkbox{
      display: flex;
      align-items: flex-start;
      /deep/ .van-checkbox__icon{
        margin-top: 4px;
      }
      .text{
        flex: 1;
        line-height: 34px;
        font-size: 28px;
        color: #F59A23;
      }
    }
  }
  .button-box{
    display: flex;
    justify-content: center;
    margin-top: 40px;
    .btn{
      flex: 1;
      background-color: #4285f5;
      border-color: #4285f5;
      border-radius: 10px;
    }
  }
}
</style>
